import { Component, Input } from '@angular/core';
import { SideBarService } from '../../../sidebar/sidebar.service';

@Component({
  selector: 'ls-sidebar-button',
  templateUrl: 'sidebar-button.component.html',
  styleUrls: ['sidebar-button.component.scss']
})
export class SidebarButtonComponent {
  @Input()
  public fixed = false;

  constructor(private sidebar: SideBarService) {}

  public toggleSidebar(): void {
    this.sidebar.toggle();
  }
}
